export const scrollToAppPromotion = () => {
  // Try immediate scroll first
  const appSection = document.getElementById('app-promotion-section');
  
  if (appSection) {
    appSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    // If not found immediately, try with a delay (in case it's still rendering)
    setTimeout(() => {
      const delayedSection = document.getElementById('app-promotion-section');
      if (delayedSection) {
        delayedSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        // Last resort: scroll to bottom
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
      }
    }, 300);
  }
};